import React from 'react';
import {Helmet} from "react-helmet";
import ContactsComponent from "../../../components/ContactsComponent";
import icon from "../../../assets/images/icons8-file-64.png";

const ComputerSciencePage = () => {

  const subjects = ['Фундаментальная информатика', 'Алгоритмы и структуры данных', 'Разработка IT-проектов', 'Операционные системы', 'Математическая экономика', 'Дискретный анализ', 'Методы оптимизации', 'Объектно-ориентированное программирование', 'Логическое и функциональное программирование', 'Искусственный интеллект', 'Теория принятия решений', 'Теория вероятностей и математическая статистика'];

  const description = "Конкурсная группа 01.03.00 'Компьютерные науки и прикладная математика' предлагает два направления: 'Прикладная математика' и 'Прикладная математика и информатика'. Здесь студенты получают возможность развивать свои навыки в компьютерных науках и математике.";
  const keywords = "Конкурсная группа 01.03.00, Компьютерные науки, Прикладная математика, Прикладная математика и информатика, математическое моделирование, анализ данных, оптимизация, программирование, информационные технологии, научные исследования, IT-индустрия, финансы";

  return (
      <div className="container">
        <Helmet>
          <meta name="description" content={description} />
          <meta name="keywords" content={keywords} />
        </Helmet>
        <h1>01.03.00</h1>
        <h1>Компьютерные науки и прикладная математика</h1>
        <div className="content">
          <h3 className="section-title">О направлении</h3>
          <div className='highlight-content'>
          <p className="section-text">
            Конкурсная группа 01.03.00 "Компьютерные науки и прикладная математика" предлагает два направления: "Прикладная математика" и "Прикладная математика и информатика". Здесь студенты получают возможность развивать свои навыки в информационных технологях и математике.
          </p>
          <p className="section-text">
            В рамках направления 01.03.04 "Прикладная математика" студенты углубляются в изучение математических концепций и их практическое применение. Они осваивают методы математического моделирования, анализа данных и оптимизации, разрабатывая умения решать сложные задачи в различных областях, от науки до экономики. Программа обучения формирует специалистов, способных применять математические подходы для решения реальных проблем.
          </p>
          <p className="section-text">
            Направление 01.03.02 "Прикладная математика и информатика" сочетает в себе глубокое понимание математических методов и навыки программирования и обработки информации. Студенты изучают алгоритмы, структуры данных, теорию вероятностей и математическую статистику, а также осваивают навыки разработки программного обеспечения. Программа обучения готовит выпускников к работе в областях разработки программ, анализа данных, искусственного интеллекта и других смежных областях.
          </p>
          {/*<p className="section-text">*/}
          {/*  Оба направления предлагают студентам качественное образование, основанное на современных достижениях в математике, информационных технологиях и вычислительной технике. В процессе обучения студенты выполняют практические задания, принимают участие в проектах и занимаются исследовательской деятельностью, что позволяет им применять полученные знания на практике.*/}
          {/*</p>*/}
          {/*<p className="section-text">*/}
          {/*  Студенты, выбравшие эту программу, получат навыки для решения сложных задач, используя современные методы математического моделирования, анализа данных и информационных технологий. Выпускники смогут успешно применять свои знания в различных областях, таких как IT-индустрия, научные исследования, финансовые учреждения, медицина и другие перспективные сферы.*/}
          {/*</p>*/}
          {/*<p className="section-text">*/}
          {/*  Программа подготовки специалистов по компьютерным наукам и прикладной математике создана для тех, кто стремится к развитию в современных технологиях и хочет применять свои знания на практике. Здесь студенты получат все необходимые инструменты и знания для успешной карьеры в области информационных технологий и научных исследований.*/}
          {/*</p>*/}
          </div>
          <h3 className="section-title">Основные дисциплины</h3>
          <div className='highlight-content'>
            <p className="section-text">
              <ul>
                {subjects.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
              </ul>
            </p>

            <div>
              <a href="https://itmai.ru/storage/01_03_00_806.pdf" target="_blank" rel="noopener noreferrer" style={{color: '#007acd', textDecoration: 'none', display: 'flex', alignItems: 'center'}}>
                <img src={icon} style={{height: '40px', marginRight: '10px'}} alt="file icon" />
                <p style={{margin: 0}}>Учебный план 01.03.02 "Прикладная математика и информатика" (каф. 806)</p>
              </a>
            </div>

            <div>
              <a href="https://itmai.ru/storage/01_03_00_802.pdf"  target="_blank" rel="noopener noreferrer" style={{color: '#007acd', textDecoration: 'none', display: 'flex', alignItems: 'center'}}>
                <img src={icon} style={{height: '40px', marginRight: '10px'}} alt="file icon" />
                <p style={{margin: 0}}>Учебный план 01.03.04 "Прикладная математика" (каф. 802)</p>
              </a>
            </div>

            <div>
              <a href="https://itmai.ru/storage/01_03_00_804.pdf" target="_blank" rel="noopener noreferrer" style={{color: '#007acd', textDecoration: 'none', display: 'flex', alignItems: 'center'}}>
                <img src={icon} style={{height: '40px', marginRight: '10px'}} alt="file icon" />
                <p style={{margin: 0}}>Учебный план 01.03.04 "Прикладная математика" (каф. 804)</p>
              </a>
            </div>

            <div>
              <a href="https://itmai.ru/storage/01_03_00_805.pdf" target="_blank" rel="noopener noreferrer" style={{color: '#007acd', textDecoration: 'none', display: 'flex', alignItems: 'center'}}>
                <img src={icon} style={{height: '40px', marginRight: '10px'}} alt="file icon" />
                <p style={{margin: 0}}>Учебный план 01.03.04 "Прикладная математика" (каф. 805)</p>
              </a>
            </div>
          </div>
          <h3 className="section-title">Проходные баллы 2023 года</h3>
          <div className='highlight-content'>
            <p className="section-text">
              Проходной балл (балл последнего зачисленного) — <span style={{color: '#007acd', fontWeight: 'bold'}}>253</span>.
            </p>
            <p className="section-text">
              Проходной балл с общежитием — <span style={{color: '#007acd', fontWeight: 'bold'}}>258</span>.
            </p>
            <p className="section-text">
              Проходной балл целевого приема — <span style={{color: '#007acd', fontWeight: 'bold'}}>194</span>.
            </p>
            <p className="section-text">
              Средний балл поступивших по общему конкурсу — <span style={{color: '#007acd', fontWeight: 'bold'}}>263</span>.
            </p>
            <p className="section-text">
              Проходной балл на платную основу — <span style={{color: '#007acd', fontWeight: 'bold'}}>200</span>.
            </p>
          </div>
        </div>
      </div>
  );
};

export default ComputerSciencePage;
